import { Button, Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  padding: "80px 120px",
  flexDirection: "column",
  alignItems: "center",
  gap: "80px",
  background: "#FCF9F7",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
    gap: "48px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 16px",
    gap: "24px",
    alignItems: "flex-start",
  },
}));

export const CardListContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "24px",
  width: "240px",
  minWidth: "240px",
  height: "100%",
  minHeight: "560px",
  padding: "24px 16px",
  borderRadius: "8px",
  border: "2px solid #d5ccf3",
  background: "#FFF",

  ...(props?.isPopular && {
    width: "100%",
    minWidth: "100%",
    border: "2px solid #512ACC",
    borderRadius: "0 0 8px 8px",
    background: "linear-gradient(180deg, #c2b2f5  0%, #F5F2FF 30%, #FFFFFF 58%, #FFFFFF 100%)",
  }),

  [props.theme.breakpoints.down("lg")]: {
    width: props?.isPopular ? "100%" : "calc(50% - 12px)",
    minWidth: props?.isPopular ? "100%" : "calc(50% - 12px)",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
    minWidth: "100%"
  },
}));

export const TaglineTitle = styling(Typography)((props) => ({
  color: "#261754",
  fontSize: "40px",
  fontWeight: "400",
  fontStyle: "normal",
  lineHeight: "48px",
  fontFamily: "Georgia",
  letterSpacing: "0.06px",

  i: {
    fontStyle: "italic",
  },

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "36px",
    lineHeight: "43.2px",
    letterSpacing: "0.36px",
    maxWidth: "620px",
    textAlign: "center",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "24px",
    lineHeight: "28.8px",
    letterSpacing: "0.036px",
    textAlign: "left",
  },
}));

export const CardContainer = styling(Grid)((props) => ({
  display: "flex",
  maxWidth: "1280px",
  alignItems: "flex-start",
  columnGap: "24px",
  rowGap: "64px",
  flexDirection: "row",
  flexWrap: "nowrap",
  justifyContent: "center",

  [props.theme.breakpoints.down("lg")]: {
    flexWrap: "wrap",
    maxWidth: "640px",
    justifyContent: "center",
  },

  [props.theme.breakpoints.down("tablet")]: {
    overflowX: "visible",
    flexWrap: "wrap",
    maxWidth: "100%",
    justifyContent: "center",
  },
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  gap: "32px",
  width: "100%",
  height: "100%",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const CardText = styling(Typography)((props) => ({
  ...(props?.type == "title" && {
    color: "#242424",
    textAlign: "left",
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "30px",
    width: "auto",
  }),

  ...(props?.type == "total" && {
    color: "rgba(0, 0, 0, 0.60)",
    textAlign: "left",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "18px",
    letterSpacing: "0.15px",
  }),

  ...(props?.type == "creditCount" && {
    color: "#000",
    textAlign: "center",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "21px",
    letterSpacing: "0.15px",
    height: "21px",
  }),

  ...(props?.type == "savedPercentage" && {
    display: "flex",
    padding: "2px 8px",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    borderRadius: "16px",
    color: "#3D784E",
    textAlign: "center",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "18px",
    height: "22px",
  }),

  ...(props?.type == "price" && {
    color: "#000",
    textAlign: "left",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "18px",
    letterSpacing: "0.15px",

    "& b": {
      color: "#000",
      fontWeight: 600,
      fontSize: "32px",
      lineHeight: "32px",
      letterSpacing: "0.15px",
    },
  }),

  ...(props?.type == "creditCount" && {
    color: "rgba(0, 0, 0, 0.60)",
    textAlign: "center",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "18px",
    letterSpacing: "0.15px",
    height: "18px",
  }),

  ...(props?.type == "desc" && {
    color: "rgba(0, 0, 0, 0.55)",
    textAlign: "left",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    letterSpacing: "0.15px",
    minHeight: "36px",
  }),

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  height: "42px",
  width: "100%",
  maxWidth: "unset",
  padding: "0px 24px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  borderRadius: "8px",
  color: "rgba(255, 255, 255, 0.87)",
  textAlign: "center",
  fontFamily: "Inter",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "700",
  lineHeight: "24px",
  letterSpacing: "0.1px",
  textTransform: "capitalize",
  whiteSpace: "nowrap",
  background: "#353535",

  ":hover": {
    background: "black",
    fontWeight: 700,
  },

  ...(!props?.isPopular && {
    background: "#FFF",
    color: "rgba(0, 0, 0, 0.87)",
    fontWeight: 500,
    lineHeight: "24px",
    letterSpacing: "0.15px",
    borderRadius: "8px",
    border: "1px solid #222",

    ":hover": {
      background: "#efefef",
    },
  }),

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    // fontSize: "20px",
    // lineHeight: "24px",
  },
}));

export const PopularCard = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  justifyContent: "flex-start",
  width: "240px",
  minWidth: "240px",
  position: "relative",

  [props.theme.breakpoints.down("lg")]: {
    width: "calc(50% - 12px)",
    minWidth: "calc(50% - 12px)",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
    minWidth: "100%",
  },
}));

export const PopularTag = styling(Grid)((props) => ({
  position: "absolute",
  top: "-30px",
  left: 0,
  right: 0,
  height: "30px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "8px 8px 0 0",
  background: "#40249B",
  color: "#fff",
  fontSize: "14px",
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: "0.15px",
  zIndex: 2,

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const SectionGrid = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  justifyContent: "center",
  textAlign: "center",
  alignItems: "center",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const HighlightList = styling(Grid)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "6px",
  width: "100%",
}));

export const HighlightItem = styling(Grid)(() => ({
  width: "100%",
  padding: "6px 8px",
  borderRadius: "4px",
  background: "#F1EEFF",
  textAlign: "center",
  fontSize: "12px",
  fontWeight: 700,
  color: "#333",
}));

export const FeatureList = styling(Grid)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "8px",
  width: "100%",
}));

export const FeatureTitle = styling(Typography)(() => ({
  fontSize: "10px",
  fontWeight: 700,
  color: "#222",
  lineHeight: "14px",
}));

export const FeatureItem = styling(Grid)(() => ({
  display: "flex",
  alignItems: "flex-start",
  textAlign: "left",
  gap: "8px",
  fontSize: "11px",
  lineHeight: "15px",
  color: "#333",
}));

export const FeatureTextWrap = styling(Grid)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
}));

export const FeatureMainText = styling("span")(() => ({
  color: "#333",
  fontSize: "13px",
  lineHeight: "150%",
  fontWeight: 400,
}));

export const FeatureDetailText = styling("span")(() => ({
  color: "rgba(0, 0, 0, 0.50)",
  fontSize: "13px",
  lineHeight: "16px",
  fontWeight: 400,
}));

export const CheckIcon = styling("span")(() => ({
  color: "#512ACC",
  fontWeight: 700,
  lineHeight: "15px",
}));

export const MoreFeaturesButton = styling(Button)(() => ({
  padding: 0,
  minWidth: "unset",
  color: "#512ACC",
  fontSize: "12px",
  fontWeight: 700,
  textTransform: "none",
  justifyContent: "flex-start",
}));

export const PackageDivider = styling(Grid)(() => ({
  width: "100%",
  borderTop: "2px dashed #D8D0F4"
}));

export const CustomPackageCard = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "16px",
  width: "240px",
  minWidth: "240px",
  minHeight: "560px",
  padding: "24px 16px",
  borderRadius: "8px",
  border: "2px solid #d5ccf3",
  background: "linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 45%, #E9E0FF 100%)",

  [props.theme.breakpoints.down("lg")]: {
    width: "100%",
    minWidth: "100%",
    minHeight: "240px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
    minWidth: "100%",
    minHeight: "360px",
  },
}));

export const CustomButtonWrap = styling(Grid)((props) => ({
  width: "100%",

  [props.theme.breakpoints.down("lg")]: {
    width: "240px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));

export const CustomIcon = styling("div")(() => ({
  color: "#512ACC",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  "& svg": {
  fontSize: "32px",
  }
}));

export const CustomTitle = styling(Typography)(() => ({
  color: "#242424",
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "22px",
  textAlign: "center",
}));

export const CustomDescription = styling(Typography)(() => ({
  color: "rgba(0, 0, 0, 0.55)",
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "18px",
  textAlign: "center",
  maxWidth: "180px",
}));

export const WhatsAppPromoCard = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "center",
  gap: "24px",
  width: "100%",
  maxWidth: "1280px",
  padding: "16px 24px 16px 40px",
  borderRadius: "8px",
  background: "#F5ECE8",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "640px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    alignItems: "flex-start",
    padding: "16px",
    gap: "16px",
  },
}));

export const WhatsAppIconCircle = styling(Grid)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "40px",
  minWidth: "40px",
  height: "40px",
  borderRadius: "50%",
  background: "#25D366",
  color: "#fff",

  "& svg": {
    fontSize: "24px",
  },
}));

export const WhatsAppPromoContent = styling(Grid)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
}));

export const WhatsAppPromoTitle = styling(Typography)(() => ({
  color: "#333",
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "20px",
}));

export const WhatsAppPromoNote = styling(Typography)(() => ({
  color: "rgba(0, 0, 0, 0.55)",
  fontSize: "14px",
  fontStyle: "italic",
  fontWeight: "400",
  lineHeight: "18px",
}));